import { Injectable } from '@angular/core';
@Injectable()
export class StorySubject {
    id?: number;
    name?: any;
}
